import React from 'react';

const DeclineCallbackModal = ({ appData, numberWithCommas, dealerNotes }) => {
    return (
        <div className="modal fade" id="decline_callback_modal" tabIndex={-1} role="dialog" aria-labelledby="decline_callback_modal" aria-hidden="true">
            <div className="modal-dialog modal-xl" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="declinecallbackmodallabel">Call Back Information</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <div className="table-responsive">
                            <p className="CB_Header">Tracir Financial Services</p>
                            <table className=" table table-striped table-bordered ">
                                <tbody>
                                    <tr>
                                        <td colSpan={2} className="text-center"><span style={{ fontSize: "12px" }}>Customer Information</span></td>
                                    </tr>
                                    <tr>
                                        <td><span className="Contact">Applicant</span></td>
                                        <td><span className="Contact">{appData.rec_app_first_name} {appData.rec_app_last_name}</span></td>
                                    </tr>
                                    <tr>
                                        <td><span className="Contact">Co-Applicant</span></td>
                                        <td><span className="Contact">{appData.rec_coapp_first_name} {appData.rec_coapp_last_name}</span></td>
                                    </tr>
                                    <tr>
                                        <td><span className="Contact">Application #</span></td>
                                        <td><span className="Contact">{appData.rec_application_number}</span></td>
                                    </tr>
                                    <tr>
                                        <td><span className="Contact">Application Date</span></td>
                                        <td><span className="Contact">{appData.app_received_date}</span></td>
                                    </tr>
                                    <tr>
                                        <td><span className="Contact">Decision Date</span></td>
                                        <td><span className="Contact">{appData.app_decision_date}</span></td>
                                    </tr>
                                    <tr>
                                        <td><span className="Contact">Status</span></td>
                                        <td><span className="Contact">{appData.rec_app_status}</span></td>
                                    </tr>
                                    <tr>
                                        <td><span className="Contact">Dealer</span></td>
                                        <td><span className="Contact">{appData.rec_dealer_name}</span></td>
                                    </tr>
                                    <tr>
                                        <td>&nbsp;</td>
                                        <td>&nbsp;</td>
                                    </tr>
                                    <tr>
                                        <td colSpan={2} className="Stip_head"><span className="Contact">Vehicle Information</span></td>
                                    </tr>
                                    <tr>
                                        <td><span className="Contact">New/Used</span></td>
                                        <td><span className="Contact">{appData.rec_veh_year}</span></td>
                                    </tr>
                                    <tr>
                                        <td><span className="Contact">Make</span></td>
                                        <td><span className="Contact">{appData.rec_veh_make}</span></td>
                                    </tr>
                                    <tr>
                                        <td><span className="Contact">Model</span></td>
                                        <td><span className="Contact">{appData.rec_veh_model}</span></td>
                                    </tr>
                                    <tr>
                                        <td><span className="Contact">Trim</span></td>
                                        <td><span className="Contact">{appData.rec_veh_trim}</span></td>
                                    </tr>
                                    <tr>
                                        <td><span className="Contact">VIN#</span></td>
                                        <td><span className="Contact">{appData.rec_vin}</span></td>
                                    </tr>
                                    <tr>
                                        <td><span className="Contact">Mileage</span></td>
                                        <td><span className="Contact">{numberWithCommas(appData.rec_veh_mileage)} miles</span></td>
                                    </tr>
                                </tbody>
                            </table>

                            <table align="center" className="table table-bordered">
                                <tbody>
                                    <tr>
                                        <td className="Notes_Head" scope="col"><span>Tracir Financial Services Notes to Dealer</span></td>
                                    </tr>
                                    <tr>
                                        <td><span style={{fontSize: "12px"}}>This application has been {appData.rec_app_status}. </span></td>
                                    </tr>
                                    <tr>
                                        <td>
                                            {dealerNotes.map((dealerNote, index) => (
                                                <p key={index}><span className="Note_item">{dealerNote}</span></p>
                                            ))}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <p>&nbsp;</p>

                            <div>
                                <table align="center" className="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th className="text-center" colSpan={2} scope="col"><span className="Contact">Analyst Information</span></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td><span className="Contact">Name</span></td>
                                            <td><span className="Contact">{appData.rec_analyst_fullname}</span></td>
                                        </tr>
                                        <tr>
                                            <td><span className="Contact">Underwriting Phone #</span></td>
                                            <td><span className="Contact">877-280-9267</span></td>
                                        </tr>
                                        <tr>
                                            <td><span className="Contact">Email:</span></td>
                                            <td><span className="Contact">Underwriting@usautocreditcorp.com</span></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default React.memo(DeclineCallbackModal);
